const ROUTES = {
  LOGIN: '/',
  DASHBOARD: '/dashboard',
  OVERVIEW: '/dashboard/overview',
  ONLINE_REVIEW: '/dashboard/online-reviews',
  FEEDBACK: '/dashboard/feedback',
  FEEDBACK_DETAILS: '/dashboard/feedback/details/:feedbackId',
  AI_INSIGHTS: '/dashboard/ai-insights',
  ALERTS: '/dashboard/alerts',
  ROOM_RANKER: '/dashboard/room_ranker',
  INVALID: '/404',
  DEFAULT: '*'
};

export default ROUTES;
